import { s3ImagesEndpoint, s3ImagesCdnEndpoint } from '../../config';

let GRADIENT_VENDOR_PREFIX = null;

const GRADIENTS = [
  ['rgba(46,21,230,0.00)', 'rgba(37,17,185,0.10)', '#13085E'],
  ['rgba(22,142,120,0.00)', 'rgba(17,164,136,0.10)', '#127864'],
  ['rgba(166,24,152,0.00)', 'rgba(166,24,152,0.10)', '#A61898'],
  ['rgba(0,135,255,0.00)', 'rgba(0,135,255,0.10)', '#0088FF'],
  ['rgba(255,121,0,0.00)', 'rgba(255,135,0,0.10)', '#FFBC00'],
  ['rgba(255,0,0,0.00)', 'rgba(255,0,0,0.10)', '#FF0000'],
  ['rgba(0,255,169,0.00)', 'rgba(0,255,169,0.10)', '#0E7753']
];

let youtubeIframeReady = false;

const getGradientVendorPrefix = () => {
  if (!GRADIENT_VENDOR_PREFIX) {
    let returnVal = ''; // default to standard syntax
    const prefixes = ['-o-', '-ms-', '-moz-', '-webkit-'];

    // Create a temporary DOM object for testing
    let dom = document.createElement('div');

    for (let i = 0; i < prefixes.length; i++) {
      // Attempt to set the style
      dom.style.background = prefixes[i] + 'linear-gradient(#000000, #ffffff)';

      // Detect if the style was successfully set
      if (dom.style.background) {
        returnVal = prefixes[i];
      }
    }

    dom = null;

    // delete dom;

    GRADIENT_VENDOR_PREFIX = returnVal;
  }

  return GRADIENT_VENDOR_PREFIX;
};

export const getGradient = (rowIndex) => {
  const gradient = GRADIENTS[rowIndex % GRADIENTS.length];

  return (
    getGradientVendorPrefix() +
    'linear-gradient(135deg, ' +
    gradient[0] +
    ' 0%, ' +
    gradient[1] +
    ' 65%, ' +
    gradient[2] +
    ' 100%)'
  );
};

export const getCloudfrontUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return '';
  }
  if (url.includes(s3ImagesEndpoint)) {
    return url.replace(s3ImagesEndpoint, s3ImagesCdnEndpoint);
  }
  return url;
};

export const setYoutubeIframeReady = () => {
  youtubeIframeReady = true;
};

export const getYoutubeIframeReady = () => !!youtubeIframeReady;
